(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-hover-value]').forEach(hoverElement => {
    hoverElement.addEventListener('mouseover', () => {
      const { hoverValue, hoverOption } = hoverElement.dataset;
      const hoveredElements = document.querySelectorAll(`[data-hovered-value="${hoverOption}"]`);

      hoveredElements.forEach(el => {
        el.textContent = hoverValue;
      });
    });

    hoverElement.addEventListener('mouseout', () => {
      const { hoverOption } = hoverElement.dataset;
      const hoveredElements = document.querySelectorAll(`[data-hovered-value="${hoverOption}"]`);

      hoveredElements.forEach(el => {
        el.textContent = el.dataset.hoveredDefaultValue || '';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
